<template>
  <div>
    <headerComponent />

    <div class="companyAuth">
      <div class="w1300">
        <div class="box">
          <h2 class="title tit-24 cor-000 txt-c">企业认证</h2>
          <!-- 企业信息区域 -->
          <el-form
            ref="enterpriseForm"
            :model="enterpriseForm"
            :rules="enterpriseRules"
            class="form-section"
          >
            <div class="small_title tit-20 fw700">企业信息</div>
            <div class="companyAuth_info flex-sbw">
              <div class="left">
                <el-form-item label="企业名称" prop="enterpriseName">
                  <el-input
                    v-model="enterpriseForm.enterpriseName"
                    placeholder="请输入您的企业名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="统一社会信用代码" prop="creditCode">
                  <el-input
                    v-model="enterpriseForm.creditCode"
                    placeholder="请输入您的企业统一社会信用代码"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="right">
                <el-form-item label="上传营业执照" prop="license">
                  <!-- v-model="enterpriseForm.license" -->
                  <!-- :file-list="licenseFileList" -->
                  <el-upload
                    ref="shangtu"
                    class="upload-qyrz"
                    :show-file-list="false"
                    list-type="picture-card"
                    :action="url"
                    :on-success="handleAvatarSuccess"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :before-upload="beforeLicenseUpload"
                    :headers="headers"
                  >
                    <div class="upload_card flex-cc">
                      <img
                        v-if="enterpriseForm.license"
                        :src="enterpriseForm.license"
                        class="img"
                      />
                      <div v-else>
                        <i class="el-icon-circle-plus tit-40 mb-10"></i>
                        <div lass="upload_text">点击上传</div>
                      </div>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      <p>1. 上传营业执照副本图片</p>
                      <p>
                        2. 确保营业执照图片清晰可见、内容真实有效、无任何修改
                      </p>
                      <p>3. 文件大小不超过10MB，格式为jpg、jpeg、png、pdf</p>
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
            </div>
          </el-form>

          <!-- 法定代表人信息区域 -->
          <el-form
            ref="legalPersonForm"
            :model="legalPersonForm"
            :rules="legalPersonRules"
            class="form-section"
          >
            <div class="small_title tit-20 fw700">法定代表人信息</div>
            <div class="companyAuth_info flex-sbw">
              <div class="left">
                <el-form-item label="法定代表人姓名" prop="legalName">
                  <el-input
                    v-model="legalPersonForm.legalName"
                    placeholder="请输入法定代表人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="法定代表人联系方式" prop="legalContact">
                  <el-input
                    v-model="legalPersonForm.legalContact"
                    placeholder="请输入法定代表人联系方式"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="right">
                <el-form-item label="上传身份证信息" prop="IDcard">
                  <el-upload
                    class="upload-qyrz"
                    :show-file-list="false"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccess2"
                    :action="url"
                    :headers="headers"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :before-upload="beforeLicenseUpload"
                  >
                    <div class="upload_card flex-cc">
                      <img
                        v-if="legalPersonForm.IDcard"
                        :src="legalPersonForm.IDcard"
                        class="img"
                      />
                      <div v-else>
                        <i class="el-icon-circle-plus tit-40 mb-10"></i>
                        <div lass="upload_text">上传人像面</div>
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item label="" prop="IDcard2">
                  <el-upload
                    class="upload-qyrz"
                    :show-file-list="false"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccess3"
                    :action="url"
                    :headers="headers"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :before-upload="beforeLicenseUpload"
                  >
                    <div class="upload_card flex-cc">
                      <img
                        v-if="legalPersonForm.IDcard2"
                        :src="legalPersonForm.IDcard2"
                        class="img"
                      />
                      <div v-else>
                        <i class="el-icon-circle-plus tit-40 mb-10"></i>
                        <div lass="upload_text">上传国徽面</div>
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
            </div>
          </el-form>

          <!-- 联系人信息区域 -->
          <el-form
            ref="contactForm"
            :model="contactForm"
            :rules="contactRules"
            class="form-section"
          >
            <div class="small_title tit-20 fw700">联系人信息</div>
            <div class="companyAuth_info flex-sbw">
              <div class="left">
                <el-form-item label="联系人姓名" prop="contactName">
                  <el-input
                    v-model="contactForm.contactName"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人地址" prop="contactAddress">
                  <el-input
                    v-model="contactForm.contactAddress"
                    placeholder="请输入联系人地址"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="right">
                <el-form-item label="联系人手机号" prop="contactPhone">
                  <el-input
                    v-model="contactForm.contactPhone"
                    placeholder="请输入联系人手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人邮箱" prop="contactEmail">
                  <el-input
                    v-model="contactForm.contactEmail"
                    placeholder="请输入联系人邮箱"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>

          <!-- 合同邮寄地址区域 -->
          <el-form
            ref="mailForm"
            :model="mailForm"
            :rules="mailRules"
            class="form-section mt-30"
          >
            <div class="small_title tit-20 fw700">合同邮寄地址</div>

            <div class="companyAuth_info flex-sbw">
              <div class="left">
                <el-form-item label="收件人姓名" prop="receiverName">
                  <el-input
                    v-model="mailForm.receiverName"
                    placeholder="请输入收件人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人手机号" prop="receiverPhone">
                  <el-input
                    v-model="mailForm.receiverPhone"
                    placeholder="请输入收件人手机号"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="right">
                <el-form-item
                  label="省市区"
                  prop="region"
                  class="mobile-cascader-item"
                >
                  <el-cascader
                    v-if="isPc"
                    v-model="mailForm.region"
                    :options="optionsnative_place"
                    placeholder="请选择省/市/区/街道"
                  ></el-cascader>

                  <div v-else class="vant-cascader-wrap">
                    <el-input
                      v-model="addressText"
                      placeholder="请选择省/市/区/街道"
                      readonly
                      @click.native="showVantCascader = true"
                    />
                    <van-popup
                      v-model="showVantCascader"
                      position="bottom"
                      round
                      class="vant-cascader-popup"
                    >
                      <van-cascader
                        v-model="vantCascaderValue"
                        :options="vantAreaOptions"
                        :field-names="{
                          text: 'text',
                          value: 'value',
                          children: 'children',
                        }"
                        :columns-num="3"
                        @close="onVantCascaderClose"
                        @finish="onVantCascaderFinish"
                        title="选择省市区"
                      />
                    </van-popup>
                  </div>
                </el-form-item>
                <el-form-item label="详细地址" prop="detailAddress">
                  <el-input
                    v-model="mailForm.detailAddress"
                    placeholder="请输入详细地址"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>

        <div class="sub flex-cc">
          <el-button type="primary" class="submit-btn" @click="handleSubmit">
            立即提交
          </el-button>
        </div>
      </div>
    </div>

    <footerComponent />
  </div>
</template>

<script>
// 引用组件
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";

// 引入省市区
import {
  provinceAndCityData, //省市二级联动数据,汉字+code
  pcTextArr, // 省市区三级联动数据
  regionData, // 省市联动数据，纯汉字
  pcaTextArr, //省市区联动数据，纯汉字
  codeToText, // 是个大对象，属性是区域码，属性值是汉字 用法例如：codeToText[‘110000’]输出北京市
} from "element-china-area-data";

// 导入Vant组件
import { Cascader, Popup } from "vant";

const optionsnative_place = pcaTextArr;
export default {
  name: "companyAuth",

  components: {
    headerComponent,
    footerComponent,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
  },
  data() {
    return {
      isPc: true, // 是否为PC端
      showVantCascader: false, // 移动端选择器弹窗显示状态
      vantCascaderValue: "", // Vant级联选择器绑定值（字符串类型）
      addressText: "", // 移动端显示的地址文本
      vantAreaOptions: [], // Vant组件专用的省市区数据
      optionsnative_place, // 省市区联动数据
      // 企业信息表单数据
      enterpriseForm: {
        enterpriseName: "",
        creditCode: "",
        license: "",
      },
      enterpriseRules: {
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        creditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
        ],
        license: [{ required: true, message: "请上传许可证", trigger: "blur" }],
      },

      licenseFileList: [], // 许可证文件

      imageUrl: "", // 预览文件
      uploadUrl: "https://jsonplaceholder.typicode.com/posts/",

      // 法定代表人信息表单数据
      legalPersonForm: {
        legalName: "",
        legalContact: "",
        IDcard2: "",
        IDcard: "",
      },
      legalPersonRules: {
        legalName: [{ message: "请输入法定代表人姓名", trigger: "blur" }],
        legalContact: [
          {
            message: "请输入法定代表人联系方式",
            trigger: "blur",
          },
        ],

        IDcard: [
          { required: true, message: "请上传身份证人像面", trigger: "change" },
        ],

        IDcard2: [
          { required: true, message: "请上传身份证国徽面", trigger: "change" },
        ],
      },

      idCardFrontList: [],
      idCardBackList: [],

      // 联系人信息表单数据
      contactForm: {
        contactName: "",
        contactAddress: "",
        contactPhone: "",
        contactEmail: "",
      },
      contactRules: {
        contactName: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        contactAddress: [
          { required: true, message: "请输入联系人地址", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系人手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        contactEmail: [
          { required: true, message: "请输入联系人邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" },
        ],
      },

      // 合同邮寄地址表单数据
      mailForm: {
        receiverName: "",
        receiverPhone: "",
        region: [],
        detailAddress: "",
      },
      mailRules: {
        receiverName: [
          { required: true, message: "请输入收件人姓名", trigger: "blur" },
        ],
        receiverPhone: [
          { required: true, message: "请输入收件人手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        region: [
          { required: true, message: "请选择省市区", trigger: "change" },
        ],
        detailAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      a: [],
      headers: { kouling: "" },
      url: "",
    };
  },
  created() {
    var that = this;
    this.url = this.$url + "&k=wenjian";
    var yonghu = this.$qu("yonghux");
    this.headers.kouling = yonghu.kouling;
    this.CSH();
    // 判断设备类型
    this.judgeDevice();
    // 转换数据格式适配vant组件
    this.vantAreaOptions = this.transformAreaData(this.optionsnative_place);
  },
  methods: {
    CSH() {
      var that = this;
      that.$post("k=renzhen", function(s) {
        if (s.shi == 0) {
          that.$xiaoxi(s.shu);
          that.$houtui();
        }
      });
    },

    // 判断设备类型（PC/移动端）
    judgeDevice() {
      const userAgent = navigator.userAgent;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent,
      );
      this.isPc = !isMobile;
    },
    // 转换省市区数据格式适配vant组件
    transformAreaData(data) {
      if (!data || !Array.isArray(data)) return [];
      return data.map((item) => {
        const transformedItem = {
          text: item.label || item.name || item.text || "",
          value: item.value || item.code || item.id || "",
          children: item.children ? this.transformAreaData(item.children) : [],
        };
        if (transformedItem.children && transformedItem.children.length === 0) {
          delete transformedItem.children;
        }
        return transformedItem;
      });
    },
    // 更新地址显示文本
    updateAddressText(value) {
      if (!value || !value.length) {
        this.addressText = "";
        return;
      }
      if (value.length >= 3) {
        this.addressText = `${value[0]} ${value[1]} ${value[2]}`;
      } else {
        this.addressText = value.join(" ");
      }
    },
    // Vant级联选择器关闭事件
    onVantCascaderClose() {
      this.showVantCascader = false;
    },
    // Vant级联选择器完成选择事件
    onVantCascaderFinish({ selectedOptions }) {
      if (selectedOptions && selectedOptions.length > 0) {
        const value = selectedOptions.map((item) => item.text);
        const text = selectedOptions.map((item) => item.text).join(" ");
        const vantValue = selectedOptions[selectedOptions.length - 1].value;
        this.mailForm.region = value;
        this.vantCascaderValue = vantValue;
        this.addressText = text;
        // console.log("Vant选择器完成选择:", { value, text, vantValue });
        this.showVantCascader = false;
        this.$nextTick(() => {
          this.$refs.mailForm.validateField("region");
        });
      }
    },

    // 预览文件
    handleAvatarSuccess(res, file) {
      var that = this;
      if (res.shi == 1) {
        that.enterpriseForm.license = res.shu.url;

        // ========== 新增：触发表单校验更新 ==========
        that.$refs.enterpriseForm.validateField("license");
      }
    },
    handleAvatarSuccess2(res, file) {
      var that = this;
      if (res.shi == 1) {
        that.legalPersonForm.IDcard = res.shu.url;
        // ========== 新增：触发身份证人像面校验更新 ==========
        that.$refs.legalPersonForm.validateField("IDcard");
      }
    },
    handleAvatarSuccess3(res, file) {
      var that = this;
      if (res.shi == 1) {
        that.legalPersonForm.IDcard2 = res.shu.url;
        // ========== 新增：触发身份证国徽面校验更新 ==========
        that.$refs.legalPersonForm.validateField("IDcard2");
      }
    },
    // 营业执照上传前校验
    beforeLicenseUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB!");
        return false;
      }
      return true;
    },

    // 提交表单
    handleSubmit() {
      var that = this;
      // 依次校验多个表单
      that.$refs.enterpriseForm.validate((enterpriseValid) => {
        that.$refs.legalPersonForm.validate((legalValid) => {
          that.$refs.contactForm.validate((contactValid) => {
            that.$refs.mailForm.validate((mailValid) => {
              if (enterpriseValid && legalValid && contactValid && mailValid) {
                // 所有表单校验通过，可发起接口请求提交数据
                const formData = {
                  enterpriseInfo: that.enterpriseForm,
                  legalPersonInfo: that.legalPersonForm,
                  contactInfo: that.contactForm,
                  mailInfo: that.mailForm,
                  // licenseFile: this.licenseFileList[0],
                  // idCardFrontFile: this.idCardFrontList[0],
                  // idCardBackFile: this.idCardBackList[0],
                };
                // console.log("提交的表单数据：", formData);

                // 这里可调用实际的接口，如：
                that.$post("k=renzhen&c=shenhe", formData, function(s) {
                  if (s.shi == 1) {
                    that.$message.success("提交成功，等待审核");
                    that.$houtui();
                  } else {
                    that.$message.error(s.shu);
                  }
                });
              } else {
                that.$message.error("请完善表单信息并确保格式正确");
              }
            });
          });
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.companyAuth {
  background: #f5f5f5;
  padding: 0.5rem 0;
  .box {
    padding: 0.3rem 0.2rem;
    background: #fff;
    h2 {
      padding: 0.2rem 0;
    }

    /deep/ .form-section {
      .small_title {
        border-bottom: 1px solid #eee;
        margin-bottom: 0.2rem;
        padding: 0.1rem 0;
      }
      .companyAuth_info {
        .el-form-item {
          .el-form-item__label {
            padding-bottom: 0.1rem;
            float: none;
            display: inline-block;
          }

          .el-form-item__content {
            .el-upload--picture-card {
              height: 155px;
              width: 240px;
              line-height: initial;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              overflow: hidden;
              .upload_card {
                .img {
                  width: 100%;
                  height: 100%;
                  display: block;
                }

                .el-icon-circle-plus {
                  color: #c0c4cc;
                }
              }
            }
            .el-upload__tip {
              font-size: var(--font14);
              line-height: 1.8;
              p {
                color: rgb(153, 153, 153);
              }
            }

            // 省市区
            .el-cascader {
              width: 100%;
            }
          }
        }

        .left {
          width: 50%;
          position: relative;
          padding-right: 0.5rem;

          &::after {
            background: #eee;
            content: "";
            display: block;
            height: 90%;
            margin-top: 5%;
            position: absolute;
            right: 0;
            top: 0;
            width: 1px;
          }
        }
        .right {
          padding-left: 0.5rem;
          width: 50%;
        }
      }
    }
  }

  .sub {
    margin-top: 0.3rem;
    button {
      padding: 0.14rem 1rem;
      background: linear-gradient(-14deg, #41b9e0 0%, #001ff5 100%);
      border-radius: 100px;
    }
  }
}

@media screen and (max-width: 767px) {
  .companyAuth .box .form-section .companyAuth_info {
    .left {
      width: 100%;
      padding-right: 0;
      &::after {
        display: none;
      }
    }
    .right {
      width: 100%;
      padding-left: 0;
    }
  }
}
</style>
